export const slideInOut = () => ({
  animate: { height: 'auto', opacity: 1 },
  initial: { height: 0, opacity: 0 },
  exit: { height: 0, opacity: 0 },
  transition: { duration: 0.3 },
});

export const translateXInOut = (distance = 20) => ({
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      default: { type: 'spring' as any, visualDuration: 0.25, bounce: 0.5 },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      opacity: { ease: 'linear' as any },
    },
  },
  initial: { x: distance, opacity: 0 },
  exit: { x: distance, opacity: 0 },
  transition: { duration: 0.3 },
});

export const translateYInOut = (distance = 20) => ({
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      default: { type: 'spring' as any, visualDuration: 0.25, bounce: 0.5 },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      opacity: { ease: 'linear' as any },
    },
  },
  initial: { y: distance, opacity: 0 },
  exit: { y: distance, opacity: 0 },
});
